import gql from 'graphql-tag'

export const GET_HERO_LIST = gql`
  query GetHeroes {
    heroes {
      id
      email
      status
      heroType
      name
      firstname
      lastname
      tel
      address
      lineId
      avatar {
        id
        url
      }
      plateLicense
      purpose
      postalAddress
      locations {
        id
        lat
        lng
        address
        radius
      }
      products {
        id
        material {
          id
          category {
            id
            name
          }
          name
          commonName
          cover {
            id
            url
          }
        }
        minQuantity
      }
    }
  }
`

export const GET_HERO_LOCATIONS = gql`
  query GetHeroLocations {
    locations {
      id
      lat
      lng
      radius
      address
      hero {
        id
        name
        heroType
        products {
          id
          material {
            id
            name
            commonName
            category{
              id
              name
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/Hero.js